import React, { useContext, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import OverlayTriggerStopLight from './OverlayTriggerStopLight';
import MissingDocumentIcon from './MissingDocumentIcon';
import { UserContext } from '@components/contexts/UserProvider';

export type ResumeChecklistProjectType = {
	name: string;
	streamConfigurationType: string;
	sco?: boolean;
	aiEnabled: boolean;
};

interface ResumeChecklistCellRendererProps {
	value: {
		key: string;
		keyValue: string;
		checkliststatus?: {
			color: string;
		};
		href?: {
			url: string;
		};
	};
	// queryParam: string;
	project: ResumeChecklistProjectType;
	data:
		| Record<
				string,
				{
					key: string;
					hasDocuments: boolean;
				}
		  >
		| { hasDocuments: boolean };
	// modalDataMutationMutate: (url: string) => void;

	// setShow: (show: boolean) => void;
	// setApiToCall: (api: string) => void;
	modalComponent?: React.FC<{
		show: boolean;
		onHide: () => void;
		apiUrl: string;
		project: ResumeChecklistProjectType;
		// sections?: Record<string, string | boolean>;
	}>;
}

const ResumeChecklistCellRenderer: React.FC<ResumeChecklistCellRendererProps> = (params) => {
	const { myUser, isPartnerUser } = useContext(UserContext);
	const isGara = params.value.keyValue?.startsWith('GARA_');
	const isGaraTemp = params.value.keyValue?.startsWith('GARATEMP_');

	const shouldOpenModal =
		(params.project.streamConfigurationType === 'STREAM' && !isGara && !isGaraTemp) ||
		(params.project.streamConfigurationType === 'WP' && myUser && isPartnerUser);

	const hasMissingDocuments =
		params.data.hasDocuments === false ||
		Object.values(params.data).find((value) => value?.key === params.value?.key)?.hasDocuments === false;

	const value = params.value.keyValue;

	const Content = () => {
		return (
			<span
				style={{
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
			>
				{hasMissingDocuments ? <MissingDocumentIcon /> : null}
				{isGara ? 'N.A.' : isGaraTemp ? 'N.D.' : value}
			</span>
		);
	};

	const [isModalOpen, setIsModalOpen] = useState(false);
	const ModalComponent = params.modalComponent;
	return (
		<>
			<Row className="align-items-center justify-content-between h-100 flex-nowrap">
				<Col className={'overflow-hidden d-flex justify-content-center'}>
					{shouldOpenModal ? (
						<Button
							variant="link"
							className="d-flex align-items-start projectModalRenderBtn"
							style={{ color: '#1C2743', overflow: 'hidden' }}
							onClick={() => {
								// params.setApiToCall(params.value.key);
								// params.modalDataMutationMutate(params.value.href.url);
								// params.setShow(true);

								setIsModalOpen(true);
							}}
						>
							<Content />
						</Button>
					) : (
						<Content />
					)}
				</Col>

				<Col xs="auto" className="pe-3">
					<OverlayTriggerStopLight checklistColor={params.value.checkliststatus?.color} isGara={isGara} isGaraTemp={isGaraTemp} />
				</Col>
			</Row>
			{ModalComponent ? (
				<ModalComponent
					show={isModalOpen}
					onHide={() => {
						setIsModalOpen(false);
					}}
					apiUrl={params.value.href?.url}
					project={params.project}
					// sections={params.data.sections}

					// projectName={params.project.name}
					// streamConfigurationType={params.project.streamConfigurationType}
				/>
			) : null}
		</>
	);
};

export default ResumeChecklistCellRenderer;
